<script>
  import page from 'page';
  import { onMount } from 'svelte';
  import { getConfig } from '@app/config';
  import { activityKeywordSetList, eventKeywordSetList, loadActivityKeywords, loadEventKeywords } from '@store/keyword-store';
  import { topLevelPlaces, loadTopLevelPlaces, isLoading as isTopLevelPlacesLoading } from '@store/place-store';
  import { currentPage } from '@store/route-store';
  import Header from './dummy/Header.svelte';
  import Footer from './dummy/Footer.svelte';
  import EventKeywordList from './smart/EventKeywordList.svelte';
  import { setTheme, darkModeEnabled } from '@store/dark-mode-store';

  const { copyrightText, header, footer } = getConfig().site;
  const { modules } = getConfig();
  const buildVersion = new Date(BUILD_VERSION);

  const eventConfig = modules.events;
  const activitiesConfig = modules.activities;

  // If we navigate to the page from outside, we might have path params
  let pathParams = window.location.pathname.split('/').filter(p => p.length > 0);
  let routeParams; // Passed to component

  onMount(() => {
    // Start router (set routes when loading modules, see loadEventsModule())
    page.start();

    // Load top level places (these are areas and municipalities)
    loadTopLevelPlaces();
    // Load modules based on what is enabled
    if (modules.events.enabled) loadEventsModule();
    if (modules.activities.enabled) loadActivitiesModule();

    // Set night mode to user preference or OS preference if no user preference set
    setTheme();

    darkModeEnabled.subscribe(value => {
      if(value != null && value === true) {
        document.documentElement.setAttribute('data-theme', 'dark');
      } else {
        document.documentElement.removeAttribute('data-theme');
      }
    });
  });

  function loadEventsModule() {
    loadEventKeywords();
    import('./smart/EventList.svelte')
      .then(module => {
        const EventList = module.default;
        const eventListRoute = { id: 'eventList', category: 'events', component: EventList };

        if (eventConfig.isDefault) {
          page('/', () => currentPage.set(eventListRoute));

          if (pathParams.length <= 1) {
            if (pathParams.length === 1 && pathParams[0] === 'event') {
              currentPage.set(eventListRoute);
            } else if (pathParams.length === 0) {
              currentPage.set(eventListRoute);
            }
          }
        }

        page('/event', () => currentPage.set(eventListRoute));

        if (pathParams.length === 1 && pathParams[0] === 'event') {
          currentPage.set(eventListRoute);
        }
      })
      .catch(err => console.log(err));

    import('./smart/EventView.svelte')
      .then(module => {
        const EventView = module.default;
        const eventViewRoute = { id: 'eventView', category: 'events', component: EventView };
        page(`/event/:eventId`, (ctx, next) => {
          routeParams = ctx.params;
          currentPage.set(eventViewRoute);
        });

        if (pathParams.length === 2 && pathParams[0] === 'event') {
          routeParams = { eventId: pathParams[1] };
          currentPage.set(eventViewRoute);
        }
      })
      .catch(err => console.log(err));
  }

  function loadActivitiesModule() {
    loadActivityKeywords();
    import('./smart/ActivityList.svelte')
      .then(module => {
        const ActivityList = module.default;
        const activityListRoute = { id: 'activityList', category: 'activities', component: ActivityList };

        if (activitiesConfig.isDefault) {
          page('/', () => currentPage.set(activityListRoute));

          if (pathParams.length <= 1) {
            if (pathParams.length === 1 && pathParams[0] === 'activity') {
              currentPage.set(activityListRoute);
            }
          } else if (pathParams.length === 0) {
            currentPage.set(activityListRoute);
          }
        }

        page('/activity', () => currentPage.set(activityListRoute));

        if (pathParams.length === 1 && pathParams[0] === 'activity') {
          currentPage.set(activityListRoute);
        }
      })
      .catch(err => console.log(err));

    import('./smart/ActivityView.svelte')
      .then(module => {
        const ActivityView = module.default;
        const activityViewRoute = { id: 'activityView', category: 'activities', component: ActivityView };
        page('/activity/:activityId', (ctx, next) => {
          routeParams = ctx.params;
          currentPage.set(activityViewRoute);
        });

        if (pathParams.length === 2 && pathParams[0] === 'activity') {
          routeParams = { activityId: pathParams[1] };
          currentPage.set(activityViewRoute);
        }
      })
      .catch(err => console.log(err));
  }
</script>

<Header header="{header}" modules="{modules}"></Header>

<main class="main">
  {#if $currentPage}
  <svelte:component this="{$currentPage.component}" routeParams="{routeParams}" />
  {/if}
</main>

<Footer logo="{footer.logo}" copyrightText="{copyrightText}" buildVersion="{buildVersion.toJSON()}"></Footer>

<style></style>
